import { render, staticRenderFns } from "./rbkform.vue?vue&type=template&id=ddd5d650&"
import script from "./rbkform.vue?vue&type=script&lang=js&"
export * from "./rbkform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports